/**
 * masterApiFactory.js
 * -------------------
 * Reusable Master API client factory.
 * Standardizes CRUD operations across all Education and General Masters
 * (Courses, Batches, Subjects, ClassRooms, Schemes, Remarks) to eliminate
 * duplicate Axios boilerplate.
 */
import api from '../../../api/client';

export function createMasterApiClient(endpoint) {
  const cleanEndpoint = endpoint.replace(/^\/+|\/+$/g, '');

  return {
    async list(params = {}) {
      const response = await api.get(`/${cleanEndpoint}/`, { params });
      return response.data;
    },

    async getById(id) {
      const response = await api.get(`/${cleanEndpoint}/${id}`);
      return response.data;
    },

    async create(payload) {
      const response = await api.post(`/${cleanEndpoint}/`, payload);
      return response.data;
    },

    async update(id, payload) {
      const response = await api.put(`/${cleanEndpoint}/${id}`, payload);
      return response.data;
    },

    async archive(id) {
      const response = await api.post(`/${cleanEndpoint}/${id}/archive`);
      return response.data;
    },

    async remove(id) {
      const response = await api.delete(`/${cleanEndpoint}/${id}`);
      return response.data;
    },

    async getDropdownOptions() {
      const response = await api.get(`/${cleanEndpoint}/options`);
      return response.data;
    },
  };
}
